import { SET_DSR_OWNER_ID } from '../../actions/dsr-actions-types'

const INITIAL_STATE_SET_DSR_OWNER_ID = { results: '' }

export function setDsrOwnerIdReducer(state = INITIAL_STATE_SET_DSR_OWNER_ID, action) {
    switch (action.type) {
        case SET_DSR_OWNER_ID:
            return { results: action.payload }
        default:
            return state;
    }
}